export const setStaleTimeInMinutes = seconds => seconds * 60 * 1000

export const setDoNotRetryOn400 = error => error.response?.status !== 400

export const setDoNotRetryOn404 = error => error.response?.status !== 404

export const setRetryLimit = (failureCount, limit) => failureCount <= limit

export default {
  setStaleTimeInMinutes,
  setDoNotRetryOn400,
  setDoNotRetryOn404,
  setRetryLimit,
}
